/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface FormateurSuiviSearch
 */
export interface FormateurSuiviSearch {
    /**
     * 
     * @type {number}
     * @memberof FormateurSuiviSearch
     */
    idFormateur?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormateurSuiviSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof FormateurSuiviSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurSuiviSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurSuiviSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof FormateurSuiviSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof FormateurSuiviSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the FormateurSuiviSearch interface.
 */
export function instanceOfFormateurSuiviSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormateurSuiviSearchFromJSON(json: any): FormateurSuiviSearch {
    return FormateurSuiviSearchFromJSONTyped(json, false);
}

export function FormateurSuiviSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormateurSuiviSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idFormateur': !exists(json, 'idFormateur') ? undefined : json['idFormateur'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function FormateurSuiviSearchToJSON(value?: FormateurSuiviSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idFormateur': value.idFormateur,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

